import { memo, useEffect, useState } from 'react';

import { connect, useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import StationsList from './StationsList/StationsList';

import { COLORS } from '../../../../utils/theme/colors';
import PencilIcon from '../../../atoms/icons/Pencil';
interface IStationGroupCardInnerContent {
  className: string;
  index: number;
  data: any[];
  filteredNotifications: any;
  routes: any;
}

interface stationGroup {
  chargeBoxGroupPk: number;
  name: string;
  status: true;
}

const StationGroupCardInnerContent = memo(({ className, index, data, routes }: IStationGroupCardInnerContent) => {
  const dispatch = useDispatch();

  const stations = useSelector((state: any) => state?.chargePoints?.chargePoints?.chargePointList ?? undefined);

  const [stationGroupSelected, setStationGroupSelected] = useState<stationGroup | null>(null);

  const [stationsByGroup, setStationsByGroup] = useState<any>(undefined);

  useEffect(() => {
    setStationGroupSelected(data[index]);
    setStationsByGroup([]);

    stationGroupSelected &&
      setStationsByGroup(
        stations?.filter((station) => station.chargeBoxGroupPk === stationGroupSelected?.chargeBoxGroupPk),
      );
  }, [stationGroupSelected, index, data, dispatch, stations]);

  return (
    <Div className={className}>
      {routes.find(({ path }) => path === '/station_groups/edit/:id') ? (
        <Link className='edit_group cursor' to={`/station_groups/edit/${stationGroupSelected?.chargeBoxGroupPk}`}>
          <p>Editar Grupo</p>
          <PencilIcon fill={'#555'} />
        </Link>
      ) : null}

      <StationsList data={stationsByGroup} />
    </Div>
  );
});

const mapStateToProps = (state) => {
  return {
    filteredNotifications: state.notifications.filteredNotifications,
    routes: state.user.routes,
  };
};

export default connect(mapStateToProps)(StationGroupCardInnerContent);

StationGroupCardInnerContent.displayName = 'StationGroupCardInnerContent';

const Div = styled.div`
  display: flex;
  flex-direction: row;

  &.gabrr_expanded {
    height: 100px !important;
  }

  .edit_group {
    margin: 0 20px;
    padding: 10px 30px;
    border-radius: 8px;
    width: 170px;
    height: 70px;
    display: flex;
    flex-direction: row;
    text-decoration: none;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    transition: background-color 200ms ease-in-out;
    background-color: rgba(0, 0, 0, 0.05);
    color: #555;

    p {
      margin: 0 10px 0 0;
    }

    :hover path {
      fill: ${COLORS.primary};
    }

    :hover {
      background-color: ${({ theme }) => theme.hoveredDiv};
      color: ${COLORS.primary};
    }
  }
`;
